/** Application-owned identity. External article copy and provider names are preserved. */
export const brand = {
  shortName: "hcmulaw",
  compactDisplayName: "ĐH Luật TP. Hồ Chí Minh",
  displayName: "Trường Đại Học Luật TP. Hồ Chí Minh",
} as const;

/** Admissions website footer, verified 2026-10-18. Provider-owned URLs stay verbatim. */
export const university = {
  website: "https://tuyensinh.hcmulaw.edu.vn/",
  admissionsEmail: "tuvantuyensinh@hcmulaw.edu.vn",
  phones: [
    { label: "1900 5555 14", href: "tel:1900555514" },
    { label: "0879 5555 14", href: "tel:0879555514" },
    { label: "0888 5555 14", href: "tel:0888555514" },
  ],
  campuses: [
    { label: "Cơ sở 1", address: "02, Nguyễn Tất Thành, P. Xóm Chiếu, TP. HCM" },
    { label: "Cơ sở 2", address: "123, Quốc lộ 13, P. Hiệp Bình, TP. HCM" },
    { label: "Cơ sở 3", address: "P. Long Phước, TP. HCM" },
    { label: "Phân hiệu", address: "Tổ Dân phố 4 Bắc Lý, P. Đồng Thuận, Tỉnh Quảng Trị" },
  ],
  zalo: { id: "3023737666786151259", url: "https://zalo.me/3023737666786151259" },
  socials: [
    { label: "Facebook", url: "https://www.facebook.com/tuyensinhdhluattphochiminh" },
    { label: "YouTube", url: "https://youtube.com/channel/UCQ2d6_EHew8VDVoLTKPS2iA" },
    { label: "Instagram", url: "https://www.instagram.com/tvts.hcmulaw?igshid=OGQ5ZDc2ODk2ZA==" },
    { label: "TikTok", url: "https://www.tiktok.com/@tuyensinhulaw?_t=8iMB1WJg6kc&_r=1" },
  ],
  sourceVerifiedOn: "2026-10-18",
} as const;
